import React, { useState } from 'react';
import { Marker, Popup } from 'react-leaflet';
import useVehicleRoute from '../hooks/useVehicleRoute';
import VehicleRoutePolyline from './map/VehicleRoutePolyline';
import { createVehicleIcon } from '../utils/map';
import { formatDelayHuman } from '../utils/time';

function VehicleMarker({ vehicle, onClick }) {
  // Przenoszę odpowiedzialność za pokazywanie ukrywanie calej trasy na widoki
  const isTram = parseInt(vehicle.routeShortName) <= 99;
  const icon = createVehicleIcon(vehicle.routeShortName, isTram, vehicle.direction);

  return (
    <Marker
      position={[vehicle.lat, vehicle.lon]}
      icon={icon}
      eventHandlers={{ 
        click: () => {
          if (onClick) onClick(vehicle);
        }
      }}
    />
  );
}

export default VehicleMarker;